import script from "./InterEcoff.vue?vue&type=script&setup=true&lang=js"
export * from "./InterEcoff.vue?vue&type=script&setup=true&lang=js"

import "./InterEcoff.vue?vue&type=style&index=0&id=13e51343&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-13e51343"]])

export default __exports__